module.exports = __webpack_public_path__ + "static/media/logos.fd5a8da7.png";